/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
export default {
  props: {
    cols: {
      type: Number,
      default: 4
    },
    height: {
      type: Number
    },
    iconBackground: {
      type: String,
      default: 'none'
    }
  }
};